import { LeftRightBasedExpression } from '../LeftRightBasedExpression.js';
export class AndExpression extends LeftRightBasedExpression {
    evaluate(visitor, localVariables) {
        const { left, right } = this._evaluateLeftRightExpression(visitor, localVariables);
        return left && right;
    }
}
//# sourceMappingURL=AndExpression.js.map